import { useAppSelector } from "@/lib/hooks";
import { optionRoleSubscription, OPTIONS_SUBSCRIPTION } from "@/models/subscription";
import { UserSubscription } from "@/models/subscriptionUser";


export const useSubscription = (licenseServer?: UserSubscription | undefined) => {
  const { license } = useAppSelector(state => state.auth);
  const options: number[] = !license?.isOutOfDate ? license?.subscription?.options || [] : [];
  const options2: number[] = !licenseServer?.isOutOfDate ? licenseServer?.subscription?.options || [] : [];
  const hasPermission = (option: OPTIONS_SUBSCRIPTION) => licenseServer ? options2.includes(option) : options.includes(option);

  const hasPermissions = (opts: OPTIONS_SUBSCRIPTION[]) => opts.every(opt => licenseServer ? options2.includes(opt) : options.includes(opt));

  const hasFullAccess = optionRoleSubscription.every(opt => licenseServer ? options2.includes(opt.id) : options.includes(opt.id));

  return {  
    hasPermission,
    hasPermissions,
    hasFullAccess,
    options,
  };
};